import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { camerasApi } from '@/api/endpoints'
import type { AudioConfigPatch } from '@/types'

export function useAudioConfig(cameraId: number, open: boolean) {
  const qc = useQueryClient()
  const key = ['camera-audio-classes', cameraId]
  const query = useQuery({ queryKey: key, queryFn: () => camerasApi.getAudioClasses(cameraId), enabled: open })
  const mutation = useMutation({
    mutationFn: (patch: AudioConfigPatch) => camerasApi.updateAudioClassConfig(cameraId, patch),
    onSuccess: (resp) => qc.setQueryData(key, resp),
    onSettled: () => qc.invalidateQueries({ queryKey: key }),
  })
  return {
    audioClasses: query.data?.audio_classes ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
    refetch: query.refetch,
    saving: mutation.isPending,
    saveError: mutation.isError,
    patch: mutation.mutate,
  }
}
